import { Component, effect, OnDestroy, OnInit } from '@angular/core';
import { MultiSelectOption } from 'src/app/shared/components/multi-select-dropdown/multi-select-dropdown.component';
import { UserPreferencesService } from 'src/app/shared/services/user-preferences/user-preferences.service';
import ColumnPreference from 'src/assets/data/columnpreference.json';
import { UserPreferenceEnum } from '../setting/setting.component';
import { MessageService } from 'primeng/api';
import { LocalStorage } from 'src/app/shared/entity/enums';
import { TaskbankColumnService } from '../../home/dashboard/task-bank/column-service/taskbank-column.service';
import { UserColumnPreferencesService } from './user-column-preferences-service/user-column-preferences.service';
import { ErrorType } from 'src/app/shared/entity/error.const';

export enum ColumnPreferenceTab {
  KPI = 'KPI Dashboard',
  TASKBANK = 'Task Bank',
  MAINKPI = 'Main KPI'
}

@Component({
    selector: 'app-column-preference',
    templateUrl: './column-preference.component.html',
    styleUrl: './column-preference.component.scss',
    standalone: false
})


export class ColumnPreferenceComponent implements OnInit, OnDestroy {

  columnList: MultiSelectOption[] = ColumnPreference.map(col => ({
    id: col.id,
    value: col.value
  }));

  selectedColumns: string[];
  ColumnPrefrences = new Map()

  ColumnPreferencesTab = [
    {
      title: ColumnPreferenceTab.KPI
    },
    {
      title: ColumnPreferenceTab.TASKBANK
    },
    {
      title: ColumnPreferenceTab.MAINKPI
    }
  ]
  activeColumnPreference = this.ColumnPreferencesTab[0]

  PreferenceTab = ColumnPreferenceTab;

  constructor(private readonly userPreferenceService: UserPreferencesService
  ,private readonly messageService: MessageService
  ,private readonly taskbankColumnService: TaskbankColumnService
  ,private readonly userColumnPreferencesService: UserColumnPreferencesService
  ) {
    this.listnerForToasterMessage();
  }

  ngOnInit(): void {
    const storedColumnPreference = localStorage.getItem(LocalStorage.ColumnPreferences);
    if (!storedColumnPreference) {
      this.getColumnPreferenceByKey();
    } else {
      const columnPreferences:any = localStorage.getItem(LocalStorage.ColumnPreferences);
      if (Array.isArray(JSON.parse(columnPreferences)) && typeof JSON.parse(columnPreferences)[0] === 'string') { 
        this.selectedColumns = ColumnPreference.map(item => item.id);
      } else {
        const Columns = columnPreferences !== 'null' && columnPreferences !== null ?  JSON.parse(columnPreferences) : ColumnPreference.map(item => item.id);
        this.selectedColumns = this.setVisibleCol(Columns).map(item => item.id);
      }
    }
    this.getUserColumnPreferences();
   }

   /**
   * Listens for toaster message updates and triggers a PrimeNG toast notification.
   * 
   * This method sets up `effect` that listens to changes in the
   * `showToaster` signal exposed by `UserColumnPreferencesService`. When the 
   * `showToaster` flag becomes `true`, it displays a toast message using 
   * `MessageService`, determining the severity (success or error) based on the
   * `error` flag in the signal.
   */
   listnerForToasterMessage() {
    effect(() => {
      const toaster = this.userColumnPreferencesService.showToaster();
      if(toaster.showToaster) {
        if(toaster.error) {
          this.messageService.add({
            severity: ErrorType.ERROR,
            closable: false,
            summary: "Error",
            detail: toaster.message??'',
          });
        }
        if(!toaster.error) {
          this.messageService.add({
            severity: ErrorType.SUCCESS,
            closable: false,
            summary: "Success",
            detail: toaster.message??'',
          });
        }
      }
    })
   }


  getUserColumnPreferences() {
    this.userColumnPreferencesService.getUserColumnPreference();
  }

  getActivePreferenceIndex(): number {
    return this.ColumnPreferencesTab.indexOf(this.activeColumnPreference);
  }

  switchTAB(index:number| string | undefined) {
    this.activeColumnPreference = this.ColumnPreferencesTab[index as number];
  }

   /**
    * To get the column list which are enable to 
    * set the value in the dropdown
    * @param Columns All Columns List 
    * @returns column name as array of string to show in the dropdown
    */
   setVisibleCol(Columns:any) {
      Columns.forEach((item:any) => {
        this.ColumnPrefrences.set(item.id, item);
      });
      const fields  =  ColumnPreference
        ?.filter((column: any) => {
          const isEnabled = this.ColumnPrefrences.get(column.id);
          return isEnabled ? isEnabled !== false && isEnabled?.enable : true;
      });
      return fields;
   }


  /**
   * To get the Column Preferences 
   */
  getColumnPreferenceByKey() {
    this.userPreferenceService.getUserPreferenceByKey(UserPreferenceEnum.TASK_BANK_COLUMNS).subscribe({
      next:(response:any) => {
        try {
          if(response?.preferenceValue !== null) {
            const columnPreferences:any = JSON.parse(response?.preferenceValue);
            this.selectedColumns = columnPreferences?.map((item:any) => item.id);
            if (Array.isArray(columnPreferences) && typeof columnPreferences[0] === 'string') { 
              this.selectedColumns = ColumnPreference.map(item => item.id);
            } else {
              const visibleFields = columnPreferences !== 'null' && columnPreferences !== null ? columnPreferences : ColumnPreference.map(item => item.id);
              this.selectedColumns = this.setVisibleCol(visibleFields)?.map(item => item.id);
            }
          }else {
            this.selectedColumns=ColumnPreference.map(item => item.id);
          }
        } catch (error) {
        }
      },
      error:(err:any) => {
        console.error(err);
        this.selectedColumns=ColumnPreference.map(item => item.id);
      }
    })
  }

  /**
   * On Change event method for multiselect Dropdown
   * @param $event event having selected values of the multiselect dropdown
   */
  onColumnSelection($event:any) {
    this.selectedColumns = $event;
    }
  
  /**
   * To Save Column Preferences 
   */
  saveColumnPreferences() {
    if(this.selectedColumns.length) {
      const params:any =  ColumnPreference.map(item => ({
        id: item.id,
        enable: this.selectedColumns.includes(item.id) ? item.enable : false,
        width: this.ColumnPrefrences.get(item.id)?.width ? this.ColumnPrefrences.get(item?.id)?.width : item?.width,
        value: item.value
      }));
      this.userPreferenceService.saveUserPreference(UserPreferenceEnum.TASK_BANK_COLUMNS, params).subscribe({
        next:(response: any) => {
          if(response?.error === null) {
            localStorage.setItem(LocalStorage.ColumnPreferences, JSON.stringify(params))
            this.taskbankColumnService.visibleColumnsList = params;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Column Preferences Saved Successfully!' });
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Network Error! Please try again.' });
          }
  
        },
        error: (err:any) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Network Error! Please try again.' });
          console.error(err);
        }
      })
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select atleast one column.' });
    }
  }

  ngOnDestroy() {
    this.userColumnPreferencesService.showToaster.set({showToaster: null, message:'', error:null})
  }

}
